module.exports = __webpack_public_path__ + "img/suika ibuki_sc2.8adecdeb.png";